// extracted by mini-css-extract-plugin
export default {"container":"chatBots_container__Jo+fr","actions":"chatBots_actions__90YCi"};